module.exports = __webpack_public_path__ + "static/img/12.313d6ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/detail/fkw/12.jpg
// module id = zdgv
// module chunks = 1